import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    courses: [],
    goTo: ""
};

const coursesSlice = createSlice({
    name: "courses",
    initialState,
    reducers: {
        init(state, action) {
            state.courses = action.payload
        },
        add(state, action) {
            state.courses = [...state.courses, action.payload]
        },
        remove(state, action) {
            state.courses = state.courses.filter(course => course.id !== action.payload)
        },
        setFrom(state, action) {
            state.goTo = action.payload
        }
    }
})

export const coursesAction = coursesSlice.actions;
export default coursesSlice;